import { INITIAL_STATE } from './initialState'
import { ChargingTokenDesignTypes } from './Actions'
import { createReducer } from 'reduxsauce'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'

export const fetchChargingTokenDesignsLoading = (state) => {
  return {
    ...state,
    fetchChargingTokenDesignsRequestState: RequestState.LOADING,
  }
}

export const fetchChargingTokenDesignsSuccess = (
  state,
  { offset, chargingTokenDesigns, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargingTokenDesigns.length; j++) {
    if (
      !state.chargingTokenDesigns.some(
        (chargingTokenDesign) =>
          chargingTokenDesign._id === chargingTokenDesigns[j]._id,
      )
    ) {
      result.push(chargingTokenDesigns[j])
    }
  }

  if (offset === 0) {
    return {
      ...state,
      fetchChargingTokenDesignsRequestState: RequestState.SUCCEEDED,
      chargingTokenDesigns: chargingTokenDesigns.map(
        (chargingTokenDesigns) => ({
          ...chargingTokenDesigns,
        }),
      ),
      paginationOffset: nextOffset,
    }
  } else {
    return {
      ...state,
      chargingTokenDesigns: [
        ...state.chargingTokenDesigns,
        ...result.map((chargingTokenDesigns) => ({
          ...chargingTokenDesigns,
        })),
      ],
      fetchChargingTokenDesignsRequestState: RequestState.SUCCEEDED,
      paginationOffset: nextOffset,
    }
  }
}

export const fetchChargingTokenDesignsError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargingTokenDesignsRequestState: requestState,
  }
}

export const fetchAllChargingTokenDesignsLoading = (state) => {
  return {
    ...state,
    fetchAllChargingTokenDesignsRequestState: RequestState.LOADING,
  }
}
export const fetchAllChargingTokenDesignsSuccess = (
  state,
  { offset, chargingTokenDesigns, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargingTokenDesigns.length; j++) {
    if (
      !state.allChargingTokenDesigns.some(
        (chargingTokenDesign) =>
          chargingTokenDesign._id === chargingTokenDesigns[j]._id,
      )
    ) {
      result.push(chargingTokenDesigns[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      fetchAllChargingTokenDesignsRequestState: RequestState.SUCCEEDED,
      allChargingTokenDesigns: chargingTokenDesigns,
      paginationOffset: nextOffset,
    }
  } else {
    return {
      ...state,
      allChargingTokenDesigns: [...state.allChargingTokenDesigns, ...result],
      fetchAllChargingTokenDesignsRequestState: RequestState.SUCCEEDED,
      paginationOffset: nextOffset,
    }
  }
}
export const fetchAllChargingTokenDesignsError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAllChargingTokenDesignsRequestState: requestState,
  }
}

export const addChargingTokenDesignLoading = (state) => {
  return {
    ...state,
    addChargingTokenDesignRequestState: RequestState.LOADING,
  }
}
export const addChargingTokenDesignSuccess = (state, { design }) => {
  return {
    ...state,
    addChargingTokenDesignRequestState: RequestState.SUCCEEDED,
    chargingTokenDesigns: [design, ...state.chargingTokenDesigns],
    count: state.count + 1,
  }
}

export const addChargingTokenDesignError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addChargingTokenDesignRequestState: requestState,
  }
}

export const editChargingTokenDesignLoading = (state) => {
  return {
    ...state,
    editChargingTokenDesignRequestState: RequestState.LOADING,
  }
}

export const editChargingTokenDesignSuccess = (state, { design }) => {
  const updatedDesign = state.chargingTokenDesigns.map((oldDesign) => {
    const isMatch = oldDesign._id === design._id

    return isMatch
      ? {
          ...oldDesign,
          name: design.name,
          base64Image: design.design,
        }
      : oldDesign
  })

  return {
    ...state,
    chargingTokenDesigns: updatedDesign,
    editChargingTokenDesignRequestState: RequestState.SUCCEEDED,
  }
}

export const editChargingTokenDesignError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    editChargingTokenDesignRequestState: requestState,
  }
}

export const clearDesigns = (state) => {
  return {
    ...state,
    chargingTokenDesigns: [],
    paginationOffset: 0,
    fetchChargingTokenDesignsRequestState: RequestState.UNINITIALIZED,
  }
}

export const deleteChargingTokenDesignLoading = (state) => {
  return {
    ...state,
    deleteChargingTokenDesignRequestState: RequestState.LOADING,
  }
}
export const deleteChargingTokenDesignSuccess = (state, { id }) => {
  const updatedDesigns = state.chargingTokenDesigns.filter(
    (design) => design._id !== id,
  )

  return {
    ...state,
    chargingTokenDesigns: updatedDesigns,
    count: state.count - 1 < 0 ? 0 : state.count - 1,
    deleteChargingTokenDesignRequestState: RequestState.SUCCEEDED,
  }
}
export const deleteChargingTokenDesignError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargingTokenDesignRequestState: requestState,
  }
}
export const getChargingTokenDesignsCountLoading = (state) => {
  return {
    ...state,
    getChargingTokenCountRequestState: RequestState.LOADING,
  }
}
export const getChargingTokenDesignsCountSuccess = (
  state,
  { chargingTokenCount },
) => {
  return {
    ...state,
    count: chargingTokenCount,
    getChargingTokenCountRequestState: RequestState.SUCCEEDED,
  }
}

export const getChargingTokenDesignsCountError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    getChargingTokenCountRequestState: requestState,
  }
}

export const resetAllDesigns = (state) => {
  return {
    ...state,
    paginationOffset: 0,
  }
}
export const reducer = createReducer(INITIAL_STATE, {
  [ChargingTokenDesignTypes.FETCH_CHARGING_TOKEN_DESIGNS_LOADING]:
    fetchChargingTokenDesignsLoading,
  [ChargingTokenDesignTypes.FETCH_CHARGING_TOKEN_DESIGNS_SUCCESS]:
    fetchChargingTokenDesignsSuccess,
  [ChargingTokenDesignTypes.FETCH_CHARGING_TOKEN_DESIGNS_ERROR]:
    fetchChargingTokenDesignsError,
  [ChargingTokenDesignTypes.FETCH_ALL_CHARGING_TOKEN_DESIGNS_LOADING]:
    fetchAllChargingTokenDesignsLoading,
  [ChargingTokenDesignTypes.FETCH_ALL_CHARGING_TOKEN_DESIGNS_SUCCESS]:
    fetchAllChargingTokenDesignsSuccess,
  [ChargingTokenDesignTypes.FETCH_ALL_CHARGING_TOKEN_DESIGNS_ERROR]:
    fetchAllChargingTokenDesignsError,
  [ChargingTokenDesignTypes.ADD_CHARGING_TOKEN_DESIGN_LOADING]:
    addChargingTokenDesignLoading,
  [ChargingTokenDesignTypes.ADD_CHARGING_TOKEN_DESIGN_SUCCESS]:
    addChargingTokenDesignSuccess,
  [ChargingTokenDesignTypes.ADD_CHARGING_TOKEN_DESIGN_ERROR]:
    addChargingTokenDesignError,
  [ChargingTokenDesignTypes.EDIT_CHARGING_TOKEN_DESIGN_LOADING]:
    editChargingTokenDesignLoading,
  [ChargingTokenDesignTypes.EDIT_CHARGING_TOKEN_DESIGN_SUCCESS]:
    editChargingTokenDesignSuccess,
  [ChargingTokenDesignTypes.EDIT_CHARGING_TOKEN_DESIGN_ERROR]:
    editChargingTokenDesignError,
  [ChargingTokenDesignTypes.CLEAR_DESIGNS]: clearDesigns,
  [ChargingTokenDesignTypes.DELETE_CHARGING_TOKEN_DESIGN_LOADING]:
    deleteChargingTokenDesignLoading,
  [ChargingTokenDesignTypes.DELETE_CHARGING_TOKEN_DESIGN_SUCCESS]:
    deleteChargingTokenDesignSuccess,
  [ChargingTokenDesignTypes.DELETE_CHARGING_TOKEN_DESIGN_ERROR]:
    deleteChargingTokenDesignError,
  [ChargingTokenDesignTypes.GET_CHARGING_TOKEN_DESIGNS_COUNT_LOADING]:
    getChargingTokenDesignsCountLoading,
  [ChargingTokenDesignTypes.GET_CHARGING_TOKEN_DESIGNS_COUNT_SUCCESS]:
    getChargingTokenDesignsCountSuccess,
  [ChargingTokenDesignTypes.GET_CHARGING_TOKEN_DESIGNS_COUNT_ERROR]:
    getChargingTokenDesignsCountError,
  [ChargingTokenDesignTypes.RESET_ALL_DESIGNS]: resetAllDesigns,
})
